import type { RecoProductCardFragment } from '@packages/gql/generated/shopping/graphql';
import type { FormattedProductProps } from '../getFormattedProduct';

export const getDiscount = (
  price: NonNullable<RecoProductCardFragment['product']>['price'],
): FormattedProductProps['price']['discount'] =>
  price.saving && price.valueOld
    ? {
        previousPrice: price.valueOld,
        wasMsrp: !!price.uvp,
        // discount flag (e.g. "-15%") should not be displayed in the recos at the moment next to UVP
        // this is the reason why this block is commented out right now
        // ...(price.saving.type === 'PERCENT'
        //   ? { discountPercentage: price.saving.value }
        //   : { priceDifference: price.saving.value }),
      }
    : undefined;
